'use strict';
const mmWidgets = require('./mm-widgets'),
	trucateSentence = require('../models/truncate-sentence'),
	goldSharingDescriptions = require('../models/gold-sharing-descriptions');

mmWidgets.fn.goldFileListItemWidget = function (editorUrl, account, subAccount, file, goldFileListModel, navigatorShim) {
	if (!goldFileListModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		if (!file || !file.description) {
			return;
		}

		const fullName = file.description || 'Unnamed map',
			displayName = trucateSentence(fullName, 43),
			isTeamFile = subAccount && file.owner === account,
			teamDescriptor = isTeamFile && 'team',
			element = this,
			modifiedDate = new Date(file.lastModified * 1000),
			thumbnailElement = element.find('[data-mm-role~="thumbnail"]'),
			thumbnailUrlFallback = '/assets/logo_256.png',
			thumbnailUrl = file.thumbnailUrl || thumbnailUrlFallback,
			roleDescription = goldSharingDescriptions[file.role] || teamDescriptor,
			fileOpener = element.find('[data-mm-role~="fileopener"]'),
			notThumbnailFallBack = () => thumbnailElement.attr('src') !== thumbnailUrlFallback;
		thumbnailElement
		.addClass('fallback')
		.on('load', () => {
			if (notThumbnailFallBack()) {
				thumbnailElement.removeClass('fallback');
			}
		})
		.on('error', () => {
			if (notThumbnailFallBack()) {
				thumbnailElement
				.attr('src', thumbnailUrlFallback);
			}
			return false;
		});

		element.find('[data-mm-role~="filename"]').text(displayName);
		element.find('[data-mm-role~="filenamefull"]').text(fullName);
		element.click(evt => {
			if (evt && evt.metaKey && !element.hasClass('single-select-only')) {
				goldFileListModel.toggleActivatedFile(file);
			} else {
				goldFileListModel.selectFile(file);
			}
		});
		element.dblclick(() => {
			if (element.hasClass('single-select-only')) {
				return;
			}

			if (goldFileListModel.getPreferedOpenType() === 'newtab') {
				navigatorShim.open(editorUrl + '/' + file.url);
			} else if (goldFileListModel.getPreferedOpenType() === 'event') {
				goldFileListModel.dispatchEvent('doubleclick', file);
			} else {
				navigatorShim.redirect(editorUrl + '/' + file.url);
			}
		});

		fileOpener.attr('href', editorUrl + '/' + file.url);
		if (goldFileListModel.getPreferedOpenType() === 'newtab') {
			fileOpener.attr('target', '_blank');
		}
		element.find('[data-mm-role~="lastmodified"]').text(modifiedDate.toDateString() + ' ' + modifiedDate.toLocaleTimeString());
		if (roleDescription) {
			element.find('[data-mm-role~="role-descriptor"]').text('(' + roleDescription + ')');
		} else {
			element.find('[data-mm-role~="role-descriptor"]').remove();
		}
		if (goldFileListModel.getActivatedFiles().includes(file)) {
			element.addClass('selected');
		}
		goldFileListModel.addEventListener('context', context => {
			if (context && context.activatedFiles && context.activatedFiles.includes(file)) {
				element.addClass('selected');
			} else {
				element.removeClass('selected');
			}
		});
		element.on('contextmenu', function (event) {
			goldFileListModel.toggleContextMenuForFile(file, {x: event.pageX, y: event.pageY});
			event.preventDefault();
		});

		thumbnailElement.attr('src', thumbnailUrl);
	});
};
